export default __webpack_public_path__ + "static/media/snail.dfdbceb7.svg";